import { render, staticRenderFns } from "./ReclamationsSupplier.vue?vue&type=template&id=7c91f337&"
import script from "./ReclamationsSupplier.vue?vue&type=script&lang=js&"
export * from "./ReclamationsSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports